export default [
  {
    template: 'image-grid',
    title:
      '<span class="font-thin">Monitoring Report</span><br /><span class="font-bold">Serbia</span><br /><span class="font-thin">2019</span>',
    images: [
      'https://upload.wikimedia.org/wikipedia/commons/f/f3/Serbian_Government_building.jpg',
      'https://images.unsplash.com/photo-1527474305487-b87b222841cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1934&q=80',
      'https://images.unsplash.com/photo-1556565681-306458ef93cd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80',
      '/Monitoring-Report-2019-Serbia.png',
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80',
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1545483656-1a34ae73add1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1527474305487-b87b222841cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1267&q=80',
      'https://images.unsplash.com/photo-1527474305487-b87b222841cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1267&q=80'
    ],
    subtitle: '<h3 class="text-center text-4xl text-sigma-green">Public Service and Human Resource Management</h3>',
    logos: [require('@/assets/full-logo.jpg')]
  },
  {
    title: 'Summary in a nutshell',
    template: 'fullscreen',
    blocks: [
      {
        component: 'tracker',
        options: {
          filterOut: [1, 2, 17, 19, 21, 23],
          groupBy: {
            Why: [1, 2],
            What: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            How: [14, 15, 16, 17]
          },
          groupColors: {
            Why: 'bg-sigma-green-light',
            What: 'bg-sigma-green',
            How: 'bg-sigma-green-dark'
          }
        }
      }
    ]
  },
  {
    title: 'Human capital is the most important resource',
    animated: true,
    order: [1, 0, 2],
    blocks: [
      `
      <div class="flex md:flex-col">
      <div class="w-150 h-150 lg:w-250 p-4 lg:h-250 mb-2 border-sigma-green-dark mx-auto rounded-full flex items-center justify-center border-4">
        <p class="text-center text-sm lg:text-xl">Capacity of government to <strong>achieve goals</strong></p>
      </div>
      <div class="w-150 h-150 lg:w-250 p-4 lg:h-250 mt-2 border-sigma-green-dark  mx-auto rounded-full flex items-center justify-center border-4">
        <p class="text-center text-sm lg:text-xl">Investors have <strong>trust</strong> in public administration</p>
      </div>
      </div>`,

      `<div class="max-w-full w-500 h-500 border-sigma-green mx-auto rounded-full flex items-center justify-center border-8 border-dashed">
        <p class="text-center text-xl lg:text-3xl font-bold">Professionalism of <br/>public service</p>
      </div>`,
      `
      <div class="flex md:flex-col">
      <div class="w-150 h-150 lg:w-250 p-4 lg:h-250 mb-2 border-sigma-green-dark mx-auto rounded-full flex items-center justify-center border-4">
        <p class="text-center text-sm lg:text-xl">Better <strong>service quality</strong> for citizens</p>
      </div>
      <div class="w-150 h-150 lg:w-250 p-4 lg:h-250 mt-2 mx-auto border-sigma-green-dark rounded-full flex items-center justify-center border-4">
        <p class="text-center text-sm lg:text-xl">Citizens have <strong>trust</strong> in public administration</p>
      </div>
      </div>`
    ],
    slides: [
      {
        title: 'HRM in the public administration sets <br/>an example for the other employers',
        template: 'versus',
        options: {
          arrows: 2,
          size: 'big'
        },
        blocks: [
          `<div class="h-full flex flex-col items-center justify-around border-8 border-dashed border-sigma-green p-8">
        <p class="text-center text-3xl">Public Administration<br/><br/>Human Resource Management</p>
        </div>`,
          `<div class="h-full flex flex-col items-center justify-around border-4 border-dashed border-sigma-green p-8 text-2xl">
        <p>Meritocracy</p>
        <p>Equality</p>
        <p>Transparency</p>
        <p>Professionalism</p>
        <p>Development</p>
        </div>`,
          `<div class="h-full flex flex-col items-center justify-around border-8 border-dashed border-sigma-green p-8 text-2xl">
        <p>Civil society</p>
        <p>Businesses</p>
        <p>SMEs</p>
        <p>Citizens</p>
        </div>`
        ]
      }
    ]
  },
  ...require('./../../shrm/shrm_2019_serbia_transformed.json').slides,
  {
    title: '<span class="font-thin not-italic text-2xl lg:text-4xl">Deliver on promise</span>',
    blocks: [
      {
        component: 'typed',
        options: {
          containerClass: 'text-center px-8 text-4xl md:text-5xl lg:text-7xl',
          content: `<span><span class="text-blue-400">policy</span> x <span class="text-yellow-500">political will</span> = <span class="text-green-400">results</span></span>`
        }
      }
    ]
  },
  {
    title: '<span class="text-white">From paper to practice</span>',
    template: 'transition',
    background:
      'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1267&q=80'
  },
  {
    title: '<span class="font-thin not-italic text-2xl lg:text-4xl">From paper to practice</span>',
    template: 'steps',
    icons: [
      {
        name: 'trophy',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'dashboard',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'compass',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      }
    ],
    blocks: [
      `<div class="tip text-xl lg:text-3xl">Implement <br/>legislation
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.1</span>
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.3</span>
      
      </div>
      
      <span class="tip-content">
      
      The Government should ensure consistent implementation of the legislation on the civil service.
      <br/><br/>
       The Government should implement the Law on Salaries in 2020 as well as all the other salary-related laws in the public sector.
       <br/><br/>
      The Government should ensure that all senior managerial positions are filled on the basis of a competitive process within the prescribed deadline in line with requirements set forth by the legislation.
      </span>`,

      `<div class="tip text-xl lg:text-3xl">Develop a unified<br/>remuneration system
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.8</span>
      
      </div>
      
      <span class="tip-content">The Government should assess the feasibility of introducing a unified remuneration system for the public sector in 2020 and consider options for phasing it in gradually.</span>`,
      `<div class="tip text-xl lg:text-3xl">Put the competency<br/>framework into action
      
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.2</span>
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">2.3</span>
      
      </div><span class="tip-content"> 
      
       The HRMS and the NAPA should ensure that the new competency framework is systematically applied. They should also help strengthen the capacity of members of selection committees in recruitment and selection; build capacity of HRM units and line managers to introduce competences in job descriptions and to conduct performance appraisals.
       <br/><br/>
       The Government should strengthen the capacity of the HRMS, so that it can perform the demanding job of testing general functional and behavioural competences of all eligible civil service applicants. 
       </span>`
    ],
    footer: '<div/>'
  },
  {
    title: '<span class="text-white">Improve capacities</span>',
    template: 'transition',
    background:
      'https://images.unsplash.com/photo-1556565681-306458ef93cd?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  },
  {
    title: '<span class=" font-thin not-italic text-2xl lg:text-4xl">Improve capacities</span>',
    template: 'steps',
    icons: [
      {
        name: 'repeat',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'clipboard',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'group',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      }
    ],
    blocks: [
      `<div class="tip text-xl lg:text-3xl">Foster co-operation</br> through networks
       
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.4</span>
      
      </div><span class="tip-content">
      
       The HRM units of the central state administration bodies should establish a formal network for co‑operation and exchange of experience in HRM matters.
       
       </span>`,
      `<div class="tip text-xl lg:text-3xl">Use full potential <br/>of performance appraisal
      
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.5</span>
      
      </div><span class="tip-content">
      Substantial training for all line managers, to fully understand the point of modern performance appraisal, should be provided. 
      </span>`,
      `<div class="tip text-xl lg:text-3xl">Provide relevant training <br/>programs
       
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.6</span>
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.9</span>
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.11</span>
      
      </div>
      <span class="tip-content">
      
      The Government should allocate separate funds for training of individual civil service bodies, to be able to design special training programmes for their staff.
      <br/>
      <br/>
      MPALSG together with the NAPA and the HRMS should prioritise the professional development of senior civil servants, both by elaborating tailored training activities and by seeking additional funding for such activities.
      <br/>
      <br/>
      The capacities of HRM units in individual institutions need to be continuously strengthened to be able to implement modern HRM tools and functions. In this respect, possibilities of technical assistance projects should be sought.
      </span>`
    ],
    footer: '<div/>'
  },
  {
    title: '<span class="text-white">Provide modern tools</span>',
    template: 'transition',
    background: 'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74'
  },
  {
    title: '<span class=" font-thin not-italic text-2xl lg:text-4xl">Provide modern tools</span>',
    template: 'steps',
    icons: [
      {
        name: 'graph-bar',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'cog',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'building',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      }
    ],
    blocks: [
      `<div class="tip text-xl lg:text-3xl">Centralise record keeping<br/> and payroll
      
      
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">1.10</span>
      
      </div>
      
      <span class="tip-content">
      
       The Government should consider the centralisation of administrative aspects of HRM, by centralising the record keeping function and payroll-related decisions (overtime pay, jubilee awards, etc.) in a shared services centre, while leaving the substantive HRM work in the individual civil service bodies.
       
       </span>
      `,
      `<div class="tip text-xl lg:text-3xl">Introduce modern information system(s) for HR functions
      
      
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">2.2</span>
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">2.5</span>
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">2.7</span>
      
      </div>
      
      <span class="tip-content"
      
      The Government (the MPALSG and the HRMS) should establish a functional HRMIS system, to help implement the CSL and allow its effective monitoring. 
      <br/>
      <br/>
      The Government (the MPALSG, the HRMS and the Ministry of Finance) should ensure that the functional HRMIS is linked to the new salary registry and other relevant registries, to improve accuracy and avoid data duplication.
      <br/>
      <br/>
      The MPALSG should publish annual data on turnover at aggregate level and by individual institutions. 
      </span>
      `,
      `<div class="tip text-xl lg:text-3xl">Link all relevant<br/> registries
      
      
      <div class="flex my-4 text-white font-bold justify-center items-center text-xl lg:text-3xl">
      
      <span class="mx-2 rounded-full h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center bg-sigma-green">2.5</span>
      
      </div><span class="tip-content">
      The MPALSG should ensure that performance appraisal is supported online, to help implement the new system.
      </span>`
    ],
    footer: '<div/>'
  },
  {
    title: '<strong>Thank you</strong><br/> for listening',
    template: 'introduction',
    logos: [require('@/assets/full-logo.jpg')],
    blocks: [
      {
        component: 'map',
        options: {
          map: 'europe',
          zoom: 7
        },
        data: {
          datasets: [
            {
              data: ['Serbia']
            }
          ]
        }
      },
      `<div class="self-center mx-auto text-justify w-4/5 lg:w-2/4 xl:w-1/5 bg-white border-2 border-dashed border-gray-600 p-4 lg:p-8 rounded-lg pointer-events-auto">
      <div class="flex justify-between text-sm md:text-normal ">
      <a class="text-center block" href="http://www.sigmaweb.org/publications/Monitoring-Report-2019-Serbia.pdf" target="_blank">
      <p class="mb-2 md:mb-8">Download the full report</p>
      <img class="h-8 md:h-12 mx-auto" src="/svg-icons/icon-download.svg"/>
      </a>
      <a class="text-center block" href="mailto:?subject=Monitoring Report 2019 - Serbia&body=Please follow this link to see the full Monitoring Report 2019 on Serbia: https://sigma.apenhet.com/public-service-and-hrm-2019.">
      <p class="mb-2 md:mb-8">Share this presentation</p>
      <img class="h-8 md:h-12 mx-auto" src="/svg-icons/icon-mail.svg"/>
      </a>
      </div>
      </div>`,
      `<div class="pointer-events-auto self-center bottom-0 absolute lg:bottom-0 text-sm md:text-normal lg:right-0 lg:mb-8 mb-16 md:mb-32 w-full mx-auto text-justify w-4/5 lg:w-1/2 xl:w-1/5 bg-white border-2 border-dashed border-gray-600 p-4 lg:p-8 rounded-lg lg:mr-8"><p class="text-left">For mor information, please do not hesitate to contact us at <a href="mailto:primoz.vehar@oecd.org">primoz.vehar@oecd.org</a> or visit the <strong><a href="http://sigmaweb.org" target="_blank">SIGMA</a></strong> website.<br/><br/>For technical issues, contact <strong><a href="mailto:contact@apenhet.com">Åpenhet</a></strong>.</p></div>`
    ]
  }
]
